module.exports = __webpack_public_path__ + "static/media/ic_zoom_out.47623e92.svg";